"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        return [_c("section", {
          staticClass: "varieties-page"
        }, [_c("header", {
          staticClass: "page-header"
        }, [_c("h1", {
          staticClass: "page-title"
        }, [_vm._v("\n          Variedades\n        ")]), _vm._v(" "), _c("b-button", {
          staticClass: "btn plant-nursery-primary-btn",
          attrs: {
            type: "is-primary"
          },
          on: {
            click: function click($event) {
              _vm.isCreateModalOpen = true;
            }
          }
        }, [_vm._v("\n          Registrar Variedade\n        ")])], 1), _vm._v(" "), _c("varieties-table", {
          attrs: {
            data: _vm.varieties,
            "is-loading": _vm.isLoading
          },
          on: {
            delete: _vm.handleDelete
          }
        }), _vm._v(" "), _vm.meta.total > _vm.meta.perPage ? _c("b-pagination", {
          staticClass: "mt-4",
          attrs: {
            total: _vm.meta.total,
            current: _vm.meta.currentPage,
            "per-page": _vm.meta.perPage,
            "range-before": "2",
            "range-after": "2",
            size: "is-small",
            order: "is-centered"
          },
          on: {
            "update:current": function updateCurrent($event) {
              return _vm.$set(_vm.meta, "currentPage", $event);
            },
            change: _vm.handlePageChange
          }
        }) : _vm._e(), _vm._v(" "), _c("create-variety", {
          attrs: {
            "is-modal-active": _vm.isCreateModalOpen,
            "is-saving": _vm.isSavingVariety
          },
          on: {
            submit: _vm.handleCreate,
            onClose: _vm.closeCreateModal
          }
        })], 1)];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;